
import { Component, Vue } from "vue-property-decorator";
import * as echarts from "echarts";
import { EchartsInfo, Obj } from "@/lib/cockpit/echartsInfo";
import request from "@/lib/request/request";
import ChinaMap from "@/views/data-cockpit/chinaMap.vue";

type EChartsOption = echarts.EChartsOption;
type ECharts = echarts.ECharts;
// 排名
class Arrnumber {
  name = "";
  number = 0;
  ranking = 0;
}
@Component({
  components: {
    ChinaMap
  }
})
export default class Cockpit extends Vue {
  minWidth = document.documentElement.clientWidth;
  minHeight = document.documentElement.clientHeight;
  isUser = true;
  t = 15;
  dataJson = require("@/lib/data/data.json");
  timer1: any = null;
  timer2: any = null;
  timer3: any = null;
  timer4: any = null;
  timer5: any = null;
  timer6: any = null;
  globalData: EchartsInfo[] = [];
  nameList: string[] = [];
  btn = true;
  statusChart: any = null;
  option: any = {};
  echartsList: object = {};

  mounted() {
    window.onresize = () => {
      window.location.reload();
    };
    this.getData();
    this.change(this.t, 1);
  }
  ranking(arr: Arrnumber[]) {
    arr.sort((a: Arrnumber, b: Arrnumber) => b.number - a.number);
    let index = 1;
    const aimask = arr.reduce((pre: Arrnumber[], cur: Arrnumber, i: number) => {
      if (!pre.find(item => item.number === cur.number)) {
        index = i + 1;
      }
      cur.ranking = index;
      pre.push(cur);
      return pre;
    }, []);
    return aimask;
  }
  // 数字长度处理
  numberLen(n: string) {
    if (!isNaN(+n)) {
      // const dom = document.getElementById(id) as HTMLElement;
      // const domC = document.getElementById(idC) as HTMLElement;
      if (n.length > 6) {
        return `${Math.pow(10, n.length - 6) * +n[0]}万+`;
      }
    }
    return n;
  }
  //   排行榜1
  get aiMaskInfo() {
    // const arr: Arrnumber[] = this.globalData[0]?.data.list || [];
    return this.ranking(this.globalData[0]?.data.list || ([] as Arrnumber[]));
  }
  //   排行榜2
  get schoolInfo() {
    // return this.globalData[1]?.data.list || [];
    return this.ranking(this.globalData[1]?.data.list || ([] as Arrnumber[]));
  }
  //   排行榜3
  get intentionInfo() {
    // return this.globalData[2]?.data.list || [];
    return this.ranking(this.globalData[2]?.data.list || ([] as Arrnumber[]));
  }
  //   数字1
  get number1() {
    return this.globalData[this.isUser ? 2 : 3]?.data.number || 0;
  }
  //   数字2
  get number2() {
    return this.globalData[this.isUser ? 3 : 4]?.data.number || 0;
  }

  beforeDestroy() {
    if (this.timer1) clearInterval(this.timer1);
    if (this.timer2) clearInterval(this.timer2);
    if (this.timer3) clearInterval(this.timer3);
    if (this.timer4) clearInterval(this.timer4);
    if (this.timer5) clearInterval(this.timer5);
    if (this.timer6) clearInterval(this.timer6);
  }
  //   获取大屏数据
  async getData() {
    const { dashboardOutId } = this.$route.query;
    const passwd = localStorage.getItem("cockpitPasswd");
    const type: any = localStorage.getItem("cockpitType");
    this.isUser = !+type;
    const resp = await request.post("/aiExam/dashboardPublic/get", {
      DashboardOutId: dashboardOutId,
      Passwd: passwd
    });
    this.globalData = resp.data.data.stepList || [];
    this.globalData.forEach((item: object) => {
      this.nameList.push(item["config"].name);
    });
    for (const key in this.echartsList) {
      this.desHander(this.echartsList[key]);
    }
    this.$nextTick(() => {
      if (this.isUser) {
        this.roll("comment3", "comment4", "review_box2", 60, 2); //排行榜2多公司
      } else {
        this.roll("comment5", "comment6", "review_box3", 60, 3); //排行榜2单公司
        this.roll("comment7", "comment8", "review_box4", 60, 4); //排行榜3单公司
      }
      this.roll("comment1", "comment2", "review_box1", 60, 1); //排行榜1多单共用
      this.pie1();
      this.pie2();
      this.pie3();
      this.pie4();
      this.pie5();
      this.pie6();
    });
  }
  // 15分钟 数据/按钮 变更
  change(t1: number, t2 = 1) {
    this.timer5 = setInterval(() => {
      this.getData();
    }, t1 * 1000 * 60);
    if (!this.isUser) {
      this.timer6 = setInterval(() => {
        this.btn = !this.btn;
        this.desHander(this.echartsList["myChart2"]);
        this.pie2();
      }, t2 * 1000 * 60);
    }
  }
  //换算方法
  nowSize(val: number, initWidth = 1920) {
    //当前视口宽度
    let nowClientWidth = this.minWidth;
    if (nowClientWidth < 1280) nowClientWidth = 1280;
    let nowClientHeight = this.minHeight;
    if (nowClientHeight < 800) nowClientHeight = 800;
    return Math.min(
      val * (nowClientWidth / initWidth),
      val * (nowClientHeight / 1080)
    );
    // return val * (nowClientWidth / initWidth);
  }
  //高度换算方法
  heightSize(val: number) {
    //当前视口宽度
    // let nowClientHeight = this.minHeight;
    // if (nowClientHeight < 800) nowClientHeight = 800;
    // return val * (nowClientHeight / initHeight);
    // return val * this.handlerScale();
    let nowClientWidth = document.documentElement.clientWidth;
    if (nowClientWidth < 1280) nowClientWidth = 1280;
    let nowClientHeight = this.minHeight;
    if (nowClientHeight < 800) nowClientHeight = 800;
    return Math.min(
      val * (nowClientWidth / 1920),
      val * (nowClientHeight / 1080)
    );
    // return val * (nowClientWidth / initHeight);
  }
  minSize(val: number) {
    return Math.min(this.heightSize(val), this.nowSize(val));
  }
  // 小数换算
  isNumber(n: number | string) {
    if (String(n).includes(".")) return Number(n).toFixed(2);
    return Number(n).toFixed();
  }
  // 条形图值不小于0
  minNumberZero(n: number | string) {
    if (isNaN(Number(n))) n = 0;
    if (Number(n) < 0) return 0;
    return Number(n);
  }
  // 清除echarts实例
  desHander(myChart: ECharts) {
    myChart.dispose();
  }
  // 环形图1
  pie1() {
    const dom = document.getElementById("pie1") as HTMLElement;
    const myChart = echarts.init(dom);
    const dw = dom.offsetWidth;
    Object.defineProperty(this.echartsList, "myChart1", {
      value: myChart,
      writable: true,
      enumerable: true,
      configurable: false
    });
    let tal = 0;
    const color = [
      "#2B8EF3",
      "#48E5E5",
      "#3254DD",
      "#BEE5FB",
      "#3CD495",
      "#E9A768"
    ];
    let option = {} as EChartsOption;
    const dataLegend2 =
      this.globalData[this.isUser ? 7 : 9]?.data.list?.map((item: object) => {
        tal += item["number"];
        return {
          value: item["number"],
          name: `${item["name"]}/${item["number"]}`,
          textStyle: {
            // color: color[index]
            color: "white"
          },
          icon: "none"
        };
      }) || [];
    const dataSeries =
      this.globalData[this.isUser ? 7 : 9]?.data.list?.map((item: object) => {
        return {
          value: item["number"],
          name: `${item["name"]}/${item["number"]}`
        };
      }) || [];
    option = {
      legend: [
        {
          top: "center",
          // left: "45%",
          // top: this.heightSize(39),
          left: this.heightSize(178.5),
          orient: "vertical",
          align: "left",
          icon: "rect",
          selectedMode: false,
          itemHeight: this.heightSize(14),
          itemWidth: this.heightSize(14),
          itemGap: this.heightSize(18),
          textStyle: {
            color: "white",
            width: dw * 0.3,
            // width: this.minWidth < 1280 ? 70 : this.nowSize(110),
            overflow: "truncate",
            fontSize: this.heightSize(14)
            // height: this.heightSize(20),
            // lineHeight: this.heightSize(20)
          },
          formatter: obj => {
            return obj.split("/")[0];
          }
        },
        {
          top: "center",
          // right: this.nowSize(-5),
          // top: this.heightSize(39),
          right: this.nowSize(-5),
          orient: "vertical",
          align: "right",
          icon: "none",
          selectedMode: false,
          itemHeight: this.heightSize(14),
          itemWidth: this.heightSize(14),
          formatter: obj => {
            const str =
              tal === 0
                ? "0%"
                : this.isNumber((+obj.split("/")[1] / tal) * 100) + "%";
            return str;
          },
          itemGap: this.heightSize(18),
          textStyle: {
            color: "white",
            fontSize: this.heightSize(14)
          },
          data: dataLegend2
        }
      ],
      series: [
        {
          // name: "Nightingale Chart",
          type: "pie",
          // radius: ["40%", "60%"],
          // center: ["20%", "50%"],
          radius: [this.heightSize(45), this.heightSize(70)],
          center: [this.heightSize(70), "50%"],
          roseType: "radius",
          animation: false,
          // width: this.nowSize(140),
          // height: this.heightSize(140),
          // top: "center",
          // left: -15,
          silent: true,
          itemStyle: {
            borderRadius: 0
          },
          label: {
            show: false,
            position: "left",
            fontSize: this.heightSize(14)
          },
          color: color,
          labelLine: {
            show: false
          },
          data: dataSeries
        }
      ]
    };
    option && myChart.setOption(option);
  }
  //   环形图3
  pie2() {
    const color = [
      "#2B8EF3",
      "#48E5E5",
      "#3254DD",
      "#BEE5FB",
      "#3CD495",
      "#E9A768"
    ];
    const dom = document.getElementById("pie2") as HTMLElement;
    const myChart = echarts.init(dom);
    const dw = dom.offsetWidth;
    Object.defineProperty(this.echartsList, "myChart2", {
      value: myChart,
      writable: true,
      enumerable: true,
      configurable: false
    });
    let tal = 0;
    let dataSeries: object[] = [];
    if (!this.isUser) {
      if (this.btn) {
        dataSeries =
          this.globalData[10]?.data["list"]?.map((item: object) => {
            tal += item["number"];
            return {
              value: item["number"],
              name: `${item["name"]}/${item["number"]}`
            };
          }) || [];
      } else {
        dataSeries =
          this.globalData[10]?.data["list2"]?.map((item: object) => {
            tal += item["number"];
            return {
              value: item["number"],
              name: `${item["name"]}/${item["number"]}`
            };
          }) || [];
      }
    } else {
      dataSeries =
        this.globalData[9]?.data["list"]?.map((item: object) => {
          tal += item["number"];
          return {
            value: item["number"],
            name: `${item["name"]}/${item["number"]}`
          };
        }) || [];
    }
    let option: EChartsOption = {};
    option = {
      legend: [
        {
          top: "center",
          // left: "50%",
          // top: this.heightSize(39),
          left: this.heightSize(178.5),
          orient: "vertical",
          align: "left",
          icon: "rect",
          selectedMode: false,
          itemHeight: this.heightSize(14),
          itemWidth: this.heightSize(14),
          itemGap: this.heightSize(18),
          textStyle: {
            color: "white",
            width: dw * 0.3,
            // width: this.minWidth < 1280 ? 70 : this.nowSize(110),
            overflow: "truncate",
            fontSize: this.heightSize(14)
          },
          formatter: obj => {
            return obj.split("/")[0];
          }
        },
        {
          top: "center",
          // right: -10,
          // top: this.heightSize(39),
          right: this.heightSize(-8),
          orient: "vertical",
          selectedMode: false,
          align: "right",
          icon: "none",
          itemHeight: this.heightSize(14),
          itemWidth: this.heightSize(14),
          itemGap: this.heightSize(18),
          textStyle: {
            fontSize: this.heightSize(14),
            color: "#FFFFFF"
          },
          formatter: obj => {
            const str =
              tal === 0
                ? "0%"
                : this.isNumber((+obj.split("/")[1] / tal) * 100) + "%";
            return str;
          },
          data: dataSeries
        }
      ],
      series: [
        {
          // name: "Access",
          type: "pie",
          // radius: ["40%", "60%"],
          // center: ["20%", "50%"],
          radius: [this.heightSize(45), this.heightSize(70)],
          center: [this.heightSize(70), "50%"],
          animation: false,
          silent: true,
          // width: this.nowSize(140),
          // height: this.heightSize(140),
          // top: "center",
          // left: 0,
          label: {
            show: true,
            position: "center",
            rich: {
              num: {
                fontSize: this.heightSize(24),
                fontWeight: "bold",
                color: "#FFFFFF",
                lineHeight: this.heightSize(34),
                height: this.heightSize(34),
                width: this.nowSize(72)
              },
              textTal: {
                fontSize: this.heightSize(14),
                fontWeight: 400,
                color: "#FFFFFF",
                lineHeight: this.heightSize(20),
                height: this.heightSize(20),
                width: this.nowSize(63)
              }
            },
            formatter: () => {
              return `{num|${tal}}\n {textTal|总数}`;
            },
            color: "white",
            // lineHeight: this.heightSize(24), //34
            fontSize: this.heightSize(14)
          },
          labelLine: {
            show: false
          },
          color: color,
          data: dataSeries
        }
      ]
    };
    option && myChart.setOption(option);
  }
  //   环形图2
  pie3() {
    const dom = document.getElementById("pie3") as HTMLElement;
    const myChart = echarts.init(dom);
    const dw = dom.offsetWidth;
    Object.defineProperty(this.echartsList, "myChart3", {
      value: myChart,
      writable: true,
      enumerable: true,
      configurable: false
    });
    let tal = 0;
    const color = [
      "#48E5E5",
      "#3254DD",
      "#2B8EF3",
      "#BEE5FB",
      "#3CD495",
      "#E9A768"
    ];
    const dataLegend2 =
      this.globalData[8]?.data.list?.map((item: object) => {
        tal += item["number"];
        return {
          value: item["number"],
          name: `${item["name"]}/${item["number"]}`,
          textStyle: {
            color: "white"
          },
          icon: "none"
        };
      }) || [];
    const dataSeries =
      this.globalData[8]?.data.list?.map((item: object) => {
        return {
          value: item["number"],
          name: `${item["name"]}/${item["number"]}`
        };
      }) || [];

    let option: EChartsOption = {};
    option = {
      legend: [
        {
          // top: this.heightSize(39),
          left: this.heightSize(178.5),
          top: "center",
          // left: "55%",
          orient: "vertical",
          align: "left",
          icon: "rect",
          selectedMode: false,
          itemHeight: this.heightSize(14),
          itemWidth: this.heightSize(14),
          itemGap: this.heightSize(18),
          textStyle: {
            color: "white",
            // width: this.heightSize(219.5),
            // width: this.minWidth < 1280 ? 70 : this.nowSize(110),
            width: dw * 0.3,
            overflow: "truncate",
            fontSize: this.heightSize(14)
          },
          formatter: obj => {
            return obj.split("/")[0];
          }
        },
        {
          top: "center",
          // right: this.nowSize(-5),
          // top: this.heightSize(39),
          right: this.heightSize(-8),
          orient: "vertical",
          align: "right",
          selectedMode: false,
          itemHeight: this.heightSize(14),
          itemWidth: this.heightSize(14),
          itemGap: this.heightSize(18),
          textStyle: {
            fontSize: this.heightSize(14)
          },
          formatter: obj => {
            const str =
              tal === 0
                ? "0%"
                : this.isNumber((+obj.split("/")[1] / tal) * 100) + "%";
            return str;
          },
          data: dataLegend2
        }
      ],
      series: [
        {
          name: "Access From",
          type: "pie",
          // radius: ["40%", "60%"],
          // center: ["21%", "50%"],
          radius: [this.heightSize(45), this.heightSize(70)],
          center: [this.heightSize(70), "50%"],
          animation: false,
          silent: true,
          //   avoidLabelOverlap: false,
          label: {
            show: true,
            position: "center",
            rich: {
              num: {
                fontSize: this.heightSize(24),
                fontWeight: "bold",
                color: "#FFFFFF",
                lineHeight: this.heightSize(34),
                height: this.heightSize(34),
                width: this.nowSize(72)
              },
              textTal: {
                fontSize: this.heightSize(14),
                fontWeight: 400,
                color: "#FFFFFF",
                lineHeight: this.heightSize(20),
                height: this.heightSize(20),
                width: this.nowSize(63)
              }
            },
            formatter: () => {
              return `{num|${tal}}\n {textTal|总人数/人}`;
            },
            color: "white",
            fontSize: this.heightSize(14)
          },
          labelLine: {
            show: false
          },
          color: color,
          data: dataSeries
        }
      ]
    };

    option && myChart.setOption(option);
  }
  //   条形图1
  pie4() {
    const dom = document.getElementById("pie4") as HTMLElement;
    const myChart = echarts.init(dom);
    Object.defineProperty(this.echartsList, "myChart4", {
      value: myChart,
      writable: true,
      enumerable: true,
      configurable: false
    });
    const xAxisData: string[] = [];
    let tal = 0;
    let maxNum = 0;
    const dataSeries =
      this.globalData[this.isUser ? 4 : 5]?.data.list?.map((item: object) => {
        xAxisData.push(item["name"]);
        tal += item["number"];
        if (maxNum < item["number"]) maxNum = item["number"];
        return {
          value: item["number"],
          symbol: "bor",
          animation: false,
          silent: true,
          itemStyle: {
            color: {
              type: "linear",
              x: 0,
              y: 0,
              x2: 1,
              y2: 0,
              colorStops: [
                {
                  offset: 0,
                  color: "#5CDAEC" // 0% 处的颜色
                },
                {
                  offset: 1,
                  color: "#2777F0" // 100% 处的颜色
                }
              ],
              globalCoord: false
            }
          }
        };
      }) || [];

    const labelSetting: echarts.PictorialBarSeriesOption["label"] = {
      show: true,
      position: "top",
      color: "#FFFFFF",
      width: this.nowSize(23),
      height: this.heightSize(14),
      lineHeight: this.heightSize(14),
      fontSize: this.heightSize(11),
      fontWeight: 600,
      // fontSize: this.heightSize(14),
      formatter: obj => {
        return `${this.isNumber((+obj.value / tal) * 100)}%`;
      }
    };
    const arrNum = String(maxNum)
      .split("")
      .map(item => {
        return +item;
      });
    if (arrNum.length) {
      if (arrNum.length === 1) {
        maxNum = 10;
      } else if (maxNum !== arrNum[0] * Math.pow(10, arrNum.length - 1)) {
        maxNum = ++arrNum[0] * Math.pow(10, arrNum.length - 1);
      }
    }
    const option = {
      title: {
        text: "人数",
        left: -5,
        top: this.heightSize(20),
        // top: this.heightSize(!this.isUser ? 0 : 17),
        textStyle: {
          fontSize: this.heightSize(14),
          color: "rgba(230,247,255,0.7)"
        }
      },
      grid: {
        left: 0,
        right: 0,
        // top: this.heightSize(45),
        // bottom: this.heightSize(40),
        // top: "15%",
        bottom: "15%",
        top: this.heightSize(62),
        // bottom: this.heightSize(50),
        containLabel: true
      },
      yAxis: {
        axisLine: { show: false },
        axisTick: { show: false },
        splitLine: {
          lineStyle: {
            type: "dashed",
            opacity: 0.1
          },
          show: true
        },
        max: maxNum,
        min: 0,
        splitNumber: 2,
        axisLabel: {
          color: "#E6F7FF",
          fontSize: this.heightSize(14)
        }
      },
      xAxis: {
        type: "category",
        data: xAxisData,
        splitLine: { show: false },
        boundaryGap: true,
        axisLabel: {
          show: true,
          color: "#E6F7FF",
          width: this.nowSize(34),
          height: this.heightSize(20),
          lineHeight: this.heightSize(20),
          fontSize: this.heightSize(14)
        },
        axisTick: {
          alignWithLabel: true,
          interval: 0,
          length: this.heightSize(5),
          show: true
        }
      },
      series: [
        {
          type: "pictorialBar",
          animation: false,
          silent: true,
          label: labelSetting,
          symbolRepeat: true,
          symbolSize: [this.nowSize(26), this.nowSize(8)],
          // symbolSize: ["70%", "20%"],
          data: dataSeries
        }
      ]
    };
    option && myChart.setOption(option);
  }
  //   条形图2
  pie5() {
    const dom = document.getElementById("pie5") as HTMLElement;
    const myChart = echarts.init(dom);
    Object.defineProperty(this.echartsList, "myChart5", {
      value: myChart,
      writable: true,
      enumerable: true,
      configurable: false
    });
    let option: EChartsOption = {};
    const yAxisData: string[] = [];
    // const seriesData: Obj[] = []; echarts.SeriesOption
    const seriesData: object[] = [];
    const colors = [
      ["rgba(30,231,231,0.35)", "#1EE7E7"],
      ["rgba(24,144,255,0.35)", "#1890FF"]
    ];
    let maxNum = 0;
    this.globalData[this.isUser ? 5 : 6]?.data.list3?.forEach(
      (item: object) => {
        yAxisData.push(item["name"]);
        item["numberList"].forEach((ls: object, index: number) => {
          if (!seriesData[index])
            seriesData?.push({
              data: [] as number[]
            } as Obj);
          seriesData[index]["name"] = ls["name"];
          seriesData[index]["type"] = "bar";
          seriesData[index]["animation"] = false;
          seriesData[index]["silent"] = true;
          // seriesData[index]["showBackground"] = true; //阴影
          seriesData[index]["barWidth"] = this.heightSize(4);
          seriesData[index]["color"] = {
            type: "linear",
            x: 0,
            y: 0,
            x2: 1,
            y2: 0,
            colorStops: [
              {
                offset: 0,
                color: colors[index][0] // 0% 处的颜色
              },
              {
                offset: 1,
                color: colors[index][1] // 100% 处的颜色
              }
            ]
          };
          if (maxNum < ls["number"]) maxNum = ls["number"];
          seriesData[index]["data"].push(this.minNumberZero(ls["number"]));
        });
      }
    );
    const arr = new Array(yAxisData.length);
    for (let i = 0; i < yAxisData.length; i++) {
      arr[i] = seriesData.length ? maxNum : this.heightSize(10);
    }
    // 添加背景
    seriesData.push({
      type: "bar",
      barWidth: this.heightSize(10),
      itemStyle: {
        color: "rgba(255,255,255,0.08)"
        // color: "rgba(28, 46, 71, 0.08)"
      },
      // barGap: "-100%",
      // barCategoryGap: "40%",
      // showBackground: true, //阴影
      data: arr,
      yAxisIndex: 1,
      animation: false
    } as echarts.SeriesOption);
    const legend1 = {
      // bottom: this.heightSize(0),
      // top: this.heightSize(-5),
      left: "center",
      // bottom: this.heightSize(50),
      bottom: "15%",
      icon: "rect",
      selectedMode: false,
      itemHeight: this.heightSize(16),
      itemWidth: this.heightSize(16),
      itemGap: this.heightSize(20),
      textStyle: {
        fontSize: this.heightSize(14),
        color: "#FFFFFF"
      }
    };
    // const legend2 = {
    //   // bottom: this.heightSize(16),
    //   // top: this.heightSize(-5),
    //   // left: "center",
    //   // bottom: "90%",
    //   icon: "rect",
    //   selectedMode: false,
    //   itemHeight: this.heightSize(16),
    //   itemWidth: this.heightSize(16),
    //   itemGap: this.heightSize(20),
    //   textStyle: {
    //     fontSize: this.heightSize(14),
    //     color: "#FFFFFF"
    //   }
    // };
    const grid1 = {
      left: 0,
      right: 0,
      // top: this.heightSize(25),
      // bottom: this.heightSize(50),
      top: this.heightSize(20),
      // bottom: "15%",
      bottom: this.heightSize(66),
      containLabel: true
    };
    // const grid2 = {
    //   left: 0,
    //   right: 0,
    //   top: "15%",
    //   bottom: "15%",
    //   // top: this.heightSize(16),
    //   // bottom: this.heightSize(1),
    //   containLabel: true
    // };
    option = {
      // legend: !this.isUser ? legend2 : legend1,
      // grid: !this.isUser ? grid2 : grid1,
      legend: legend1,
      grid: grid1,
      xAxis: {
        type: "value",
        axisLine: { show: false },
        axisTick: { show: false },
        axisLabel: {
          show: false
        },
        min: 0,
        max: maxNum,
        splitNumber: 2,
        show: false,
        boundaryGap: [0, 0.01]
      },
      yAxis: [
        {
          type: "category",
          data: yAxisData,
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            color: "#E6F7FF",
            fontSize: this.heightSize(14)
          }
        },
        {
          type: "category",
          show: false
        }
      ],
      series: seriesData
    };
    option && myChart.setOption(option);
  }

  //   条形图3
  pie6() {
    const dom = document.getElementById("pie6") as HTMLElement;
    const myChart = echarts.init(dom);
    Object.defineProperty(this.echartsList, "myChart6", {
      value: myChart,
      writable: true,
      enumerable: true,
      configurable: false
    });
    let option: EChartsOption = {};
    const seriesData: object[] = [];
    const color = ["#E9A768", "#A8EA8A", "#2B8EF3", "#5CDAEC"];
    const yAxisData: string[] = [];
    this.globalData[this.isUser ? 6 : 7]?.data.list3?.forEach(
      (item: object) => {
        yAxisData.push(item["name"]);
        item["numberList"].forEach((ls: object, index: number) => {
          if (!seriesData[index])
            seriesData?.push({
              data: [] as number[]
            } as Obj);
          seriesData[index]["name"] = ls["name"];
          seriesData[index]["type"] = "bar";
          seriesData[index]["barGap"] = this.heightSize(3);
          seriesData[index]["barWidth"] = this.heightSize(10);
          seriesData[index]["animation"] = false;
          seriesData[index]["silent"] = true;
          seriesData[index]["stack"] = "series";
          seriesData[index]["backgroundStyle"] = {
            color: "rgba(255,255,255,0.03)"
          };
          seriesData[index]["showBackground"] = true; //阴影
          if (index) {
            seriesData[index]["itemStyle"] = {
              shadowOffsetX: this.heightSize(-1),
              shadowColor: "#fff"
            };
          }
          seriesData[index]["data"].push(this.minNumberZero(ls["number"]));
        });
      }
    );
    option = {
      color: color,
      legend: {
        // bottom: this.heightSize(!this.isUser ? 20 : 0),
        icon: "rect",
        bottom: "15%",
        selectedMode: false,
        itemHeight: this.heightSize(14),
        itemWidth: this.heightSize(14),
        itemGap: this.heightSize(10),
        textStyle: {
          color: "white",
          fontSize: this.heightSize(14)
        }
      },
      grid: {
        left: 0,
        right: 0,
        top: !this.isUser ? "15%" : "5%",
        bottom: !this.isUser ? "15%" : "25%",
        // top: this.heightSize(30),
        // bottom: this.heightSize(30),
        containLabel: true
      },
      xAxis: {
        type: "value",
        axisLine: { show: false },
        axisTick: { show: false },
        // splitLine: {
        //   lineStyle: {
        //     type: "dashed",
        //     width: this.nowSize(1),
        //     color: "rgba(230,247,255,0.2)"
        //     // opacity: 1
        //   },
        //   show: true
        // }
        show: false
      },
      yAxis: {
        type: "category",
        nameGap: this.heightSize(20),
        inverse: true,
        data: yAxisData,
        axisLine: {
          show: false
        },
        axisTick: {
          show: false
        },
        axisLabel: {
          color: "white",
          fontSize: this.heightSize(14)
        }
      },
      series: seriesData
    };
    option && myChart.setOption(option);
  }
  // 轮播
  roll(el1: string, el2: string, content: string, t: number, i: number) {
    this.$nextTick(() => {
      const ul1 = document.getElementById(el1) as HTMLElement;
      // const ul2 = document.getElementById(el2) as HTMLElement;
      const ulbox = document.getElementById(content) as HTMLElement;
      if (ul1.offsetHeight <= ulbox.offsetHeight) return;
      // ul2.innerHTML = ul1.innerHTML;
      ulbox.scrollTop = 0;
      this.rollStart(el1, el2, content, t, i);
    });
  }
  rollStart(el1: string, el2: string, content: string, t: number, i: number) {
    if (![null, undefined].includes(this[`setTimeout${i}`]))
      clearInterval(this[`setTimeout${i}`]);
    const ul1 = document.getElementById(el1) as HTMLElement;
    // const ul2 = document.getElementById(el2) as HTMLElement;
    const ulbox = document.getElementById(content) as HTMLElement;
    this.rollStop(i);
    this[`timer${i}`] = setInterval(() => {
      // 当滚动高度大于列表内容高度时恢复为0  ulbox.scrollTop >= ul1.scrollHeight
      if (
        (ulbox.scrollTop === ul1.offsetHeight - ulbox.offsetHeight &&
          ul1.offsetHeight - ulbox.offsetHeight >=
            ul1.offsetHeight / ul1.children.length) ||
        ulbox.scrollTop + 1 === ul1.offsetHeight - ulbox.offsetHeight
      ) {
        this.rollStop(i);
        this[`setTimeout${i}`] = setTimeout(() => {
          ulbox.scrollTop = 0;
          this.rollStart(el1, el2, content, t, i);
        }, 1000);
      } else {
        ulbox.scrollTop++;
        if (
          ul1.offsetHeight - ulbox.offsetHeight <
          ul1.offsetHeight / ul1.children.length
        ) {
          this.rollStop(i);
        }
      }
    }, t);
  }
  rollStop(index: number) {
    clearInterval(this[`timer${index}`]);
  }
}
